<template>
    <v-card class="rounded-lg" style="height: 100%" color="#efeded">
        <v-card-text>
            <!-- Color Pickers -->
            <v-row class="mt-1">
                <v-col class="text-right py-0">
                    <v-icon @click="dialog = true" color="primary">mdi-brush-outline</v-icon>
                </v-col>

            </v-row>
            <v-dialog v-model="dialog" persistent max-width="500px">
                <v-card>
                    <div class="card-title">
                        {{ $t('ChangeColor')}}
                    </div>
                    <v-card-title></v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="6">
                                <v-color-picker v-model="greenColor"
                                                mode="hexa"
                                                label="Pick Green Color"></v-color-picker>
                            </v-col>
                            <v-col cols="6">
                                <v-color-picker v-model="amberColor"
                                                mode="hexa"
                                                label="Pick Amber Color"></v-color-picker>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="dialog = false" text>{{$t('Close')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-row v-if="value.length>0" style="margin: auto; margin-right: 10px; margin-top: 0px;">
                <v-col>
                    <v-card class="elevation-0" style="background-color: #efeded; border-radius: 15px;">

                        <v-card-text class="d-flex align-center justify-space-around">
                            <v-container>
                                <v-row>
                                    <v-col cols="6" v-for="(item, index) in value" :key="index" class="text-center" @click="filterQuestionOption(item)">
                                        <img v-if="item.name == 'سعودي'" src="../../assets/images/ksaUser.png" alt="" />
                                        <v-icon v-if="item.name == 'غير سعودي'" size="70" :color="amberColor">mdi-account-tie</v-icon><br />
                                        <span v-if="value" style="font-size: 21px; color: #000;">{{item.name}}</span><br />
                                        <span :style="{ color: item.name == 'سعودي'?greenColor:amberColor, fontSize: '21px' }">{{ item.value }}%</span><br />


                                    </v-col>

                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card></v-col></v-row>
    <!-- Values Section -->
    <!--<v-row class="mt-3" v-for="(item, index) in value" :key="index" @click="filterQuestionOption(item)">
        <v-col cols="2">
            <img v-if="item.name == 'سعودي'" src="../../assets/images/ksaUser.png" alt="" />
            <v-icon v-if="item.name == 'غير سعودي'" size="70" :color="amberColor">mdi-account-tie</v-icon>
        </v-col>
        <v-col cols="2">
            <h2 class="pt-6" :style="{ color: item.name == 'سعودي'?greenColor:amberColor }">
                {{ item.value }} %
            </h2>
        </v-col>
        <v-col cols="5">
            <v-rating background-color="grey lighten-1"
                      class="pt-4"
                      :color="item.name == 'سعودي'?greenColor:amberColor"
                      :value="computedRating(item.value)"
                      :length="maxStars"
                      half-increments
                      readonly></v-rating>
        </v-col>
        <v-col>
            <h3 class="pt-6" style="color: #000;">{{ item.name }}</h3>
        </v-col>
    </v-row>-->


</v-card-text>
                    </v-card>
</template>
<script>
    export default {
        props: {
            value: {
                type: Array,
                default: () => [],
            },
            q: undefined
        },
        data() {
            return {
                maxStars: 5,
                greenColor: '#7bb093', // Default green color
                amberColor: '#bf9000', // Default amber color
                dialog:false
            }
        },
        methods: {
            computedRating(percentage) {
                return (percentage / 100) * this.maxStars
            },
            filterQuestionOption(item) {
                this.$emit('filterQuestionOption', item, this.q, this.value)
            }
        },
    }
</script>
<style scoped>
</style>
